var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Btn_Messages",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 152.421,
    height: 155,
    viewBox: "0 0 152.421 155",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 152.421,
    height: 155,
    fill: "#1152e4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M162.852,152.556H109.673a4.875,4.875,0,1,1,0-9.749h53.179a16.521,16.521,0,0,0,16.5-16.5V85.543a16.521,16.521,0,0,0-16.5-16.5H138.537a4.875,4.875,0,1,1,0-9.749h24.315A26.282,26.282,0,0,1,189.1,85.543V126.3a26.282,26.282,0,0,1-26.252,26.252",
    transform: "translate(-36.683 -20.754)",
    fill: "#1152e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M32.557,152.556H26.252A26.282,26.282,0,0,1,0,126.3V85.543A26.282,26.282,0,0,1,26.252,59.291H46.98a4.875,4.875,0,0,1,0,9.749H26.252a16.521,16.521,0,0,0-16.5,16.5V126.3a16.521,16.521,0,0,0,16.5,16.5h6.305a4.875,4.875,0,1,1,0,9.749",
    transform: "translate(0 -20.754)",
    fill: "#1152e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M37.89,220.73a4.875,4.875,0,0,1-4.67-6.275l6.96-23.2a4.875,4.875,0,0,1,9.339,2.8l-3.741,12.469L80.39,189.445a4.875,4.875,0,1,1,4.314,8.743L40.047,220.227a4.866,4.866,0,0,1-2.157.5",
    transform: "translate(-11.556 -65.73)",
    fill: "#1152e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M95.972,111.8a4.875,4.875,0,0,1-4.363-2.7c-2.989-5.994-29.192-59.04-29.192-75.55a33.555,33.555,0,0,1,67.109,0c0,16.51-26.2,69.556-29.192,75.55a4.875,4.875,0,0,1-4.363,2.7m0-102.055a23.832,23.832,0,0,0-23.8,23.8c0,3.314,1.808,13,13.915,40.638,3.586,8.186,7.2,15.927,9.89,21.57,2.691-5.643,6.3-13.383,9.89-21.57,12.108-27.638,13.916-37.323,13.916-40.638a23.832,23.832,0,0,0-23.806-23.8",
    transform: "translate(-21.849)",
    fill: "#1152e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M104.948,62.286A16.889,16.889,0,1,1,121.837,45.4a16.908,16.908,0,0,1-16.889,16.889m0-24.029a7.14,7.14,0,1,0,7.14,7.14,7.147,7.147,0,0,0-7.14-7.14",
    transform: "translate(-30.824 -9.978)",
    fill: "#1152e4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageDefault);
export default __webpack_public_path__ + "static/media/message-default.222c252dc6ae8750ed1ff79c5fae1902.svg";
export { ForwardRef as ReactComponent };